import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { GameIntroScene } from "./GameIntro";
import { InstructionScene } from "./InstructionScene";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.DiseasedTrees;
        this.mainScene = InstructionScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "DiseasedTrees.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "DiseasedTrees.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "DiseasedTrees.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/DiseasedTreesGame/scenes/IntroductionScene.ts